<div class="agGridOuterDiv">


  <!-- TOOLBAR -->
  <mat-toolbar class="agGridtopersDiv card"
    style="background: rgb(228 227 230 / 41%);
     margin-top:1%;
           border-top: 1px solid #a9a9a9a8;
           border-right: 1px solid #a9a9a9a8;
           border-left: 1px solid #a9a9a9a8;">

      <!-- HEADER -->
  <div class="popup-header" *ngIf="title">
    {{ title }}
  </div>       

    <span class="example-spacer"></span>

    <!-- SEARCH -->
    <div>
      <input
        type="text"
        placeholder="Search..."
        (input)="onQuickFilterChanged($event)"
        style="padding-left: 5px;
               height: 32px;
               color: gray;
               font-size: 17px;
               margin: 10px;
               border-radius: 5px;
               background: rgb(228 227 230 / 41%);
               border: 1px solid #a9a9a9a8;" />
    </div>

    <!-- PAGE NUMBER -->
    <div class="insertPageNoDiv">
      <mat-form-field appearance="outline">
        <mat-label>Page No</mat-label>
        <input matInput type="number" (input)="onSearchChange($event.target.value)">
      </mat-form-field>
    </div>

    <!-- PAGE SIZE -->
    <div class="selectRecordsDiv" style="width:9.5%">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Records</mat-label>
        <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
          <mat-option [value]="10">10</mat-option>
          <mat-option [value]="50">50</mat-option>
          <mat-option [value]="100">100</mat-option>
          <mat-option [value]="200">200</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- PAGINATION -->
    <div class="card pagination paginationFirstButton paginationFirstlastButton">
      <em class="fas fa-angle-double-left" (click)="onBtFirst()"></em>
    </div>

    <div class="card pagination paginationButtons btn-rounded" style="width: 120px;">
      <ul>
        <li><em class="fas fa-angle-left" (click)="onBtPrevious()"></em></li>
        <li>{{currentPage}} / {{totalPages}}</li>
        <li><em class="fas fa-angle-right" (click)="onBtNext()"></em></li>
      </ul>
    </div>

    <div class="card pagination paginationLastButton paginationFirstlastButton">
      <em class="fas fa-angle-double-right" (click)="onBtLast()"></em>
    </div>

  </mat-toolbar>

  <!-- AG GRID -->
  <ag-grid-angular
    class="ag-theme-balham"
    style="width: 100%; height: 70vh; "
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [pagination]="true"
    [paginationPageSize]="paginationPageSize"
    [suppressPaginationPanel]="true"
    [rowHeight]="35"
    [enableBrowserTooltips]="true"
    [headerHeight]="35"
    (gridReady)="onGridReady($event)"
    (paginationChanged)="onPaginationChanged()">
  </ag-grid-angular>

</div>